export type Site =
  | 'datadoghq.com'
  | 'us3.datadoghq.com'
  | 'us5.datadoghq.com'
  | 'datadoghq.eu'
  | 'ddog-gov.com'
  | 'ap1.datadoghq.com'

// The RUM SDK is imported dynamically, so it stays out of the entry chunk. The import
// starts right away (not after hydration) so RUM initialises early enough to record the
// first view's paint metrics.
export default defineNuxtPlugin((nuxtApp) => {
  const {
    datadogApplicationId,
    datadogClientToken,
    datadogSite,
    datadogService,
    environment,
    version,
  } = nuxtApp.$config.public

  if (!datadogApplicationId) {
    return
  }

  import('@datadog/browser-rum')
    .then(({ datadogRum }) => {
      datadogRum.init({
        applicationId: datadogApplicationId,
        clientToken: datadogClientToken,
        site: datadogSite as Site,
        service: datadogService,
        env: environment,
        version: version.split('/').pop(),
        sessionSampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        // forward dd traceid when fetches are to the following urls
        allowedTracingUrls: [(url) => url.includes('airalo.com')],
      })
    })
    .catch((err) => {
      console.error('Not connected to Datadog', err)
    })
})
